import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import React from 'react';
import { Toaster } from 'react-hot-toast';
import Container from '../components/Container';
import PageHeader from '../components/PageHeader';
import { config } from '../config';

const TheExchange = dynamic(() => import('../components/TheExchange'), { ssr: false });

function Exchange() {
  const description = `Win a chance to exchange your Heepow for a newly designed Heepow using $grass.`;

  return (
    <>
      <NextSeo title={`Exchange - ${config.collectionName}`} description={description} />
      <PageHeader title='Exchange' description={description} image='/heepows/smokey.png' />

      {process.env.NEXT_PUBLIC_EXCHANGE_ENABLED === 'true' ? (
        <>
          <TheExchange />
        </>
      ) : (
        <div className='mt-10'>
          <Container>
            <p>Exchange is currently disabled. Stay tuned.</p>
          </Container>
        </div>
      )}
      <Toaster position='bottom-center' />
    </>
  );
}

export default Exchange;
